/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  next: {
    defaultMessage: `Next`,
    id: 'app.start.next.button'
  },
  previous: {
    defaultMessage: `Previous`,
    id: 'app.start.previous.button'
  },
  welcome: {
    defaultMessage: `Hi, I'm Sporti. I live on a planet nearby! Today, I'm your personal travel guide! I will take you to your prefered sport planets.`,
    id: 'app.start.welcome.text'
  },
  formIntro: {
    defaultMessage: `But enough about me, what's your name?`,
    id: 'app.start.form.text'
  },
  formLabelFirstName: {
    defaultMessage: `Firstname:`,
    id: 'app.start.form.label.firstname'
  },
  formLabelSurname: {
    defaultMessage: `Surname:`,
    id: 'app.start.form.label.surname'
  },
  intro: {
    defaultMessage: `Nice to meet you {firstname}.<br>To pick the best sport planets, I'll have to get to know you. I'll show you a movement, and you indicate how much you like it!`,
    id: 'app.start.intro.text'
  },
  ready: {
    defaultMessage: `Awesome!<br>Let's begin!<br>Ready?`,
    id: 'app.start.ready.text'
  }
});



// WEBPACK FOOTER //
// ./src/containers/start/messages.js